/* eslint-disable import/no-anonymous-default-export */
/**
 * 리뷰 캠페인 관리 설정
 */
import RefundBadge from "../components/RefundBadge";

function getStatusLabel(status) {
  switch (status) {
    case "waiting":
      return "대기중";
    case "processing":
      return "처리중";
    case "completed":
      return "완료";
    default:
      return status;
  }
}

function getReviewScoreTypeLabel(type) {
  switch (type) {
    case "high":
      return "평점 5점만";
    case "row":
      return "자연스러운 평점";
    default:
      return type || "-";
  }
}

function getReviewTypeLabel(type) {
  switch (type) {
    case "kakao":
      return "카카오 리뷰";
    default:
      return type || "-";
  }
}

export default {
  id: "adReview",
  title: "[리뷰 등록]신청 관리",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type",
      params: { type: "review" },
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type/count",
      params: { type: "review" },
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
      version: 2,
      type: "review",
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/campaigns/by-type",
    },
  },

  filters: {
    default: {
      type: [],
      productType: ["kakao"],
      keyword: "",
      submitDate: "",
      status: "전체",
      submitted: "전체",
      paid: "전체",
      page: 1,
      limit: 50,
    },
    schema: [
      {
        name: "productType",
        label: "상품 타입",
        type: "checkbox-group",
        options: [{ value: "kakao", label: "카카오 리뷰" }],
      },
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 플레이스명",
      },
      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "processing", label: "처리중" },
          { value: "completed", label: "완료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "processingCount", label: "진행중" },
      { key: "completedCount", label: "완료" },
    ],
  },

  table: {
    keyField: "adReviewId",
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "신청자(ID)\n접수일\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              <span className="user-name">
                {row.userName}
                {row.userId ? ` (${row.userId})` : ""}
              </span>
            </div>
            <div>{row.submitDate || "-"}</div>
            <div>
              <span className={`badge badge-${row.status}`}>{getStatusLabel(row.status)}</span>
            </div>
          </>
        ),
      },
      {
        key: "startDate",
        label: "시작일\n종료일\n작업일수",
        center: true,
        render: (row) => {
          let calculatedDays = row.executionDays;
          if (!calculatedDays && row.startDate && row.endDate) {
            const start = new Date(row.startDate);
            const end = new Date(row.endDate);
            const diffTime = end - start;
            calculatedDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
          }

          return (
            <>
              <div>
                <span
                  className="date-blue"
                  data-campaign-meta-id={row.adCampaignMetaId}
                  data-start-date={row.startDate}
                  data-end-date={row.endDate}
                  style={{ cursor: "pointer" }}
                >
                  {row.startDate}
                </span>
              </div>
              <div>
                <span className="date-red">{row.endDate}</span>
              </div>
              <div>{calculatedDays || 0}일</div>
            </>
          );
        },
      },
      {
        key: "totalInflow",
        label: "총수량\n일수량\n총금액(단가)",
        center: true,
        render: (row) => {
          const unitPrice = row.totalCount && row.totalAmount ? Math.floor(row.totalAmount / row.totalCount) : 0;
          return (
            <>
              <div>{row.totalCount?.toLocaleString()}건</div>
              <div>{row.dailyCount?.toLocaleString()}건</div>
              <div>
                {row.totalAmount?.toLocaleString()}원 ({unitPrice?.toLocaleString()}원)
              </div>
            </>
          );
        },
      },
      {
        key: "placeName",
        label: "플레이스명\n연락처\nURL",
        center: true,
        render: (row) => (
          <>
            <div>{row.placeName || "-"}</div>
            <div>{row.phoneNum || "-"}</div>
            <div>
              {row.placeUrl ? (
                <a href={row.placeUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                  {row.placeUrl}
                </a>
              ) : (
                "-"
              )}
            </div>
          </>
        ),
      },
      {
        key: "type",
        label: "점수타입\n리뷰종류",
        center: true,
        render: (row) => (
          <>
            <div>{getReviewScoreTypeLabel(row.reviewScoreType)}</div>
            <div>{getReviewTypeLabel(row.reviewType)}</div>
          </>
        ),
      },
      {
        key: "guideline",
        label: "요청사항\n금지단어(선택)",
        center: true,
        render: (row) => (
          <>
            <div className="guideline-textbox" title={row.guideline || "-"} data-review-id={row.adReviewId}>
              {row.guideline || "-"}
            </div>
            <div>{row.excludedKeywords || "-"}</div>
          </>
        ),
      },
      {
        key: "paymentType",
        label: "결제방법\n결제상태",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.paymentType === "card"
                ? "카드"
                : row.paymentType === "v_bank"
                  ? "가상계좌"
                  : row.paymentType === "account"
                    ? "계좌이체"
                    : row.paymentType === "point"
                      ? "포인트 결제"
                      : row.paymentType
                        ? row.paymentType
                        : "-"}
            </div>
            <div>
              {row.isRefunded === 1 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? "결제완료" : "미결제"}`}>
                  {row.isPaid === 1 ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "report",
        label: "리포트",
        center: true,
        render: (row) => (
          <button
            type="button"
            className="status-btn submitted"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-place-name={row.placeName || ""}
          >
            리포트
          </button>
        ),
      },
      {
        key: "notification",
        label: "알림톡",
        center: true,
        render: (row) => {
          const reviewTypeLabel = getReviewTypeLabel(row.type);
          const productName = reviewTypeLabel || "리뷰 등록 신청";

          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount={row.totalAmount ?? ""}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : "메모"}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수/취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        // submitted는 adCampaignMetaId 사용
        const selectedItems = items.filter((item) => selectedIds.includes(item.adReviewId));
        const adCampaignMetaIds = [...new Set(selectedItems.map((item) => item.adCampaignMetaId).filter((id) => id))];
        const hasUnsubmitted = selectedItems.some((item) => item.isSubmitted !== 1);
        return {
          type: "review",
          action: "submitted",
          ids: adCampaignMetaIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some((item) => selectedIds.includes(item.adReviewId) && item.isPaid === 1);
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds, items) => {
        // paid는 adPaymentTransactionId 사용
        const selectedItems = items.filter((item) => selectedIds.includes(item.adReviewId));
        const adPaymentTransactionIds = [
          ...new Set(selectedItems.map((item) => item.adPaymentTransactionId).filter((id) => id)),
        ];
        return {
          type: "review",
          action: "paid",
          ids: adPaymentTransactionIds,
          toggleValue: 1,
        };
      },
    },
    {
      id: "complete",
      label: "처리완료/취소",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        // complete는 각 캠페인 개별 ID (adReviewId) 사용
        const selectedItems = items.filter((item) => selectedIds.includes(item.adReviewId));
        const hasUncompleted = selectedItems.some((item) => item.isCompleted !== 1);
        return {
          type: "review",
          action: "completed",
          ids: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0,
        };
      },
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adReviewId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const selectedCampaigns = items.filter((campaign) => selectedIds.includes(campaign.adCampaignMetaId));
        const hasInvalidCampaign = selectedCampaigns.some((campaign) => {
          const userName = campaign.userName || "";
          return (
            !userName.includes("테스트") &&
            !userName.includes("전유상") &&
            !userName.includes("이령빈") &&
            !userName.includes("서한석") &&
            !userName.includes("null") &&
            !userName.includes("채영호") &&
            !userName.includes("매니저")
          );
        });
        const hasNotTerminatedCampaign = selectedCampaigns.some(
          (campaign) => !(campaign.status === "종료" && campaign.paid === "notComplete"),
        );
        return !(hasInvalidCampaign && hasNotTerminatedCampaign);
      },
      confirm: "선택한 리뷰 캠페인을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds, items) => {
        const filteredSelectedIds = items
          .filter((item) => selectedIds.includes(item.adReviewId))
          .map((item) => item.adReviewId);
        return {
          type: "review",
          ids: filteredSelectedIds,
        };
      },
    },
  ],

  download: {
    type: "xlsx",
    fileName: "리뷰캠페인_신청목록.xlsx",
    sheetName: "리뷰캠페인신청목록",
    transformRow: (row) => {
      // 작업일수 계산
      let calculatedDays = row.executionDays;
      if (!calculatedDays && row.startDate && row.endDate) {
        const start = new Date(row.startDate);
        const end = new Date(row.endDate);
        const diffTime = end - start;
        calculatedDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      }

      // 단가 계산
      const unitPrice = row.totalCount && row.totalAmount ? Math.floor(row.totalAmount / row.totalCount) : 0;

      return {
        신청자: row.userName || "",
        접수일: row.submitDate || "",
        상태: getStatusLabel(row.status),
        시작일: row.startDate || "",
        종료일: row.endDate || "",
        작업일수: (calculatedDays || 0) + "일",
        총수량: (row.totalCount || 0) + "건",
        일수량: (row.dailyCount || 0) + "건",
        단가: (unitPrice || 0) + "원",
        총금액: (row.totalAmount || 0) + "원",
        점수타입: getReviewScoreTypeLabel(row.reviewScoreType),
        리뷰종류: getReviewTypeLabel(row.reviewType),
        플레이스명: row.placeName || "",
        연락처: row.phoneNum || "",
        플레이스URL: row.placeUrl || "",
        가이드라인: row.guideline || "",
        제외키워드: row.excludedKeywords || "",
      };
    },
  },
};
